import classNames from "classnames";
import React from "react";
import { PdfTemplateDesignerModule } from "./usePdfTemplateDesigner";
import { ActionButtons } from "../../Buttons";
import { faEye, faEyeSlash, faSave } from "@fortawesome/free-solid-svg-icons";

export interface PdfTemplateDesignerHeaderToolbarProps {
  allowPreview?: boolean;
  onPreviewToggle: (isPreview: boolean) => void;
  hideFieldsTab?: boolean;
  templateDesignerModule?: PdfTemplateDesignerModule;
  designerHeaderContent?: React.ReactNode;
}

export const PdfTemplateDesignerHeaderToolbar: React.FC<
  PdfTemplateDesignerHeaderToolbarProps
> = (props) => {
  const [isPreview, setIsPreview] = React.useState<boolean>(false);

  React.useEffect(() => {
    props.onPreviewToggle(isPreview);
  }, [isPreview, props]);

  return (
    <div className="header-toolbar">
      <div className="header-toolbar-page-thumbnails">
        <h3>Page Thumbnails</h3>
      </div>
      <div className="header-toolbar-application-form">
        <h3>{props.designerHeaderContent || "Form Designer"}</h3>
        <div className="header-toolbar-actions">
          <ActionButtons
            actions={[
              ...(props.allowPreview
                ? [
                    {
                      buttonClassStyle: classNames("preview-template", {
                        "is-preview": isPreview,
                      }),
                      iconProps: {
                        icon: isPreview ? faEyeSlash : faEye,
                      },
                      text: isPreview ? "Exit Preview" : "Preview",
                      onActionClick: () => setIsPreview(!isPreview),
                      isDisabled: () =>
                        !!props.templateDesignerModule?.isSaving,
                    },
                  ]
                : []),
              ...(!!props.templateDesignerModule?.save
                ? [
                    {
                      buttonClassStyle: classNames("save-template", {
                        "is-saving": props.templateDesignerModule?.isSaving,
                      }),
                      iconProps: {
                        icon: faSave,
                      },
                      text: props.templateDesignerModule?.isSaving
                        ? "Saving"
                        : "Save",
                      onActionClick: () => {
                        props.templateDesignerModule?.save();
                      },
                      isDisabled: () => !!isPreview,
                      isPrimary: true,
                    },
                  ]
                : []),
            ]}
          />
        </div>
      </div>
      {!props.hideFieldsTab && (
        <div className="header-toolbar-expression-toolbar">
          {!isPreview && <h3>Fields</h3>}
          {isPreview && <h3>Preview</h3>}
        </div>
      )}
    </div>
  );
};
